import { FC } from 'react';
import classNames from 'classnames';

import { ReactComponent as Chevron } from '@rikstv/play-common/src/icons/svg/chevron-light.svg';
import { PrimaryButton } from '@rikstv/shared-components';

import styles from './ScrollArrow.module.css';

export const ScrollArrow: FC<{
  right?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  withBorder?: boolean;
  hidden?: boolean;
}> = ({ right, disabled = false, onClick, className, withBorder = false, hidden = false }) => {
  if (hidden) {
    return null;
  }

  return (
    <PrimaryButton
      aria-label={right ? 'Neste' : 'Forrige'}
      onClick={() => {
        onClick?.();
      }}
      className={classNames(
        styles.scrollNavigationArrow,
        'with-keyboard-focus',
        className,
        { [styles.right]: right },
        { [styles.disabled]: disabled },
        { [styles.withBorder]: withBorder }
      )}
      icon={Chevron as any}
      iconClass={styles.innerIcon}
      disabled={disabled}
    />
  );
};
